const TRACE_METADATA_TAIL = /\n*\*\*TRACE METADATA[\s\S]*$/i;
const STANDALONE_EMPTY_JSON = /^\s*\[\s*\]\s*$/gm;
const SYSTEM_REMINDER = /<system_reminder>[\s\S]*?<\/system_reminder>/gi;
const TODO_UPDATED_PREFIX = /^Todos updated successfully\.?\s*/i;

const readJsonText = (value: string): string => {
  const trimmed = value.trim();

  if (
    (!trimmed.startsWith('"') || !trimmed.endsWith('"')) &&
    (!trimmed.startsWith('[') || !trimmed.endsWith(']'))
  ) {
    return value;
  }

  try {
    const parsed: unknown = JSON.parse(trimmed);

    if (typeof parsed === 'string') {
      return parsed;
    }

    if (!Array.isArray(parsed)) {
      return value;
    }

    const text = parsed
      .flatMap((part) => {
        if (typeof part === 'string') {
          return [part];
        }

        if (!part || typeof part !== 'object') {
          return [];
        }

        const record = part as Record<string, unknown>;

        return typeof record.text === 'string' ? [record.text] : [];
      })
      .join('\n\n')
      .trim();

    return text || value;
  } catch {
    return value;
  }
};

export function stripInvestigationWriteup(value: string): string {
  const withoutInternalContent = value
    .replace(SYSTEM_REMINDER, '')
    .replace(TODO_UPDATED_PREFIX, '')
    .trim();
  const readableText = readJsonText(withoutInternalContent);

  return readableText
    .replace(TRACE_METADATA_TAIL, '')
    .replace(STANDALONE_EMPTY_JSON, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function readVisibleAgentWriteup(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  const stripped = stripInvestigationWriteup(value);

  return stripped.length > 0 ? stripped : undefined;
}

export function readVisibleAnalystNarration(
  value: unknown,
): string | undefined {
  const message = readVisibleAgentWriteup(value);

  if (!message) {
    return undefined;
  }

  const trimmed = message.trim();
  const structuredPayloadMarkers = [
    '"todos"',
    '"targetFile"',
    '"target_file"',
    '"tool_calls"',
    '"tool_use"',
  ];

  if (
    trimmed.startsWith('{') ||
    structuredPayloadMarkers.some((marker) => trimmed.includes(marker))
  ) {
    return undefined;
  }

  const structuredCharacterCount = [...trimmed].filter((character) =>
    ['{', '}', '"'].includes(character),
  ).length;

  return structuredCharacterCount / trimmed.length > 0.08 ? undefined : message;
}
